import React, { useState } from 'react';
import { useAssetContext } from '../contexts/AssetContext';

const Settings = () => {
  const { state, dispatch } = useAssetContext();
  const [newDefiWallet, setNewDefiWallet] = useState('');

  const handleExchangeConfigChange = (exchange, field, value) => {
    dispatch({
      type: 'UPDATE_EXCHANGE_CONFIG',
      payload: {
        exchange,
        config: { [field]: value }
      }
    });
  };

  const toggleExchange = (exchange) => {
    dispatch({
      type: 'TOGGLE_EXCHANGE',
      payload: exchange
    });
  };

  const addDefiWallet = () => {
    if (newDefiWallet.trim()) {
      dispatch({
        type: 'ADD_DEFI_WALLET',
        payload: newDefiWallet.trim()
      });
      setNewDefiWallet('');
    }
  };

  const removeDefiWallet = (wallet) => {
    dispatch({
      type: 'REMOVE_DEFI_WALLET',
      payload: wallet
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Settings</h2>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium text-gray-700 mb-4">Exchange Configuration</h3>
        
        {/* Binance */}
        <div className="mb-6 pb-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-medium text-gray-900">Binance</h4>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={state.exchanges.binance.enabled}
                onChange={() => toggleExchange('binance')}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>
          {state.exchanges.binance.enabled && (
            <div className="space-y-4 pl-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">API Key</label>
                <input
                  type="password"
                  value={state.exchanges.binance.apiKey}
                  onChange={(e) => handleExchangeConfigChange('binance', 'apiKey', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your Binance API key"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Secret Key</label>
                <input
                  type="password"
                  value={state.exchanges.binance.secret}
                  onChange={(e) => handleExchangeConfigChange('binance', 'secret', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your Binance secret key"
                />
              </div>
            </div>
          )}
        </div>

        {/* OKX */}
        <div className="mb-6 pb-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-medium text-gray-900">OKX</h4>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={state.exchanges.okx.enabled}
                onChange={() => toggleExchange('okx')}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>
          {state.exchanges.okx.enabled && (
            <div className="space-y-4 pl-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">API Key</label>
                <input
                  type="password"
                  value={state.exchanges.okx.apiKey}
                  onChange={(e) => handleExchangeConfigChange('okx', 'apiKey', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your OKX API key"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Secret Key</label>
                <input
                  type="password"
                  value={state.exchanges.okx.secret}
                  onChange={(e) => handleExchangeConfigChange('okx', 'secret', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your OKX secret key"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Passphrase</label>
                <input
                  type="password"
                  value={state.exchanges.okx.passphrase}
                  onChange={(e) => handleExchangeConfigChange('okx', 'passphrase', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your OKX passphrase"
                />
              </div>
            </div>
          )}
        </div>

        {/* Hyperliquid */}
        <div className="mb-6 pb-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-medium text-gray-900">Hyperliquid</h4>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={state.exchanges.hyperliquid.enabled}
                onChange={() => toggleExchange('hyperliquid')}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>
          {state.exchanges.hyperliquid.enabled && (
            <div className="space-y-4 pl-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Wallet Address</label>
                <input
                  type="text"
                  value={state.exchanges.hyperliquid.apiKey}
                  onChange={(e) => handleExchangeConfigChange('hyperliquid', 'apiKey', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your Hyperliquid wallet address"
                />
              </div>
              <p className="text-sm text-gray-500">
                Note: Hyperliquid only requires your wallet address to fetch public information like balances and positions.
              </p>
            </div>
          )}
        </div>

        {/* Aster */}
        <div className="mb-6 pb-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-medium text-gray-900">Aster</h4>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={state.exchanges.aster.enabled}
                onChange={() => toggleExchange('aster')}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
          </div>
          {state.exchanges.aster.enabled && (
            <div className="space-y-4 pl-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">API Key</label>
                <input
                  type="password"
                  value={state.exchanges.aster.apiKey}
                  onChange={(e) => handleExchangeConfigChange('aster', 'apiKey', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your Aster API key"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Secret Key</label>
                <input
                  type="password"
                  value={state.exchanges.aster.secret}
                  onChange={(e) => handleExchangeConfigChange('aster', 'secret', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your Aster secret key"
                />
              </div>
            </div>
          )}
        </div>

        {/* DeFi Wallets */}
        <div>
          <h4 className="font-medium text-gray-900 mb-4">DeFi Wallets</h4>
          <div className="pl-4">
            <div className="flex space-x-2 mb-4">
              <input
                type="text"
                value={newDefiWallet}
                onChange={(e) => setNewDefiWallet(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter wallet address"
              />
              <button
                onClick={addDefiWallet}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Add
              </button>
            </div>
            
            {state.exchanges.defiWallets.length > 0 && (
              <div className="mt-4">
                <h5 className="text-sm font-medium text-gray-700 mb-2">Added Wallets:</h5>
                <ul className="space-y-2">
                  {state.exchanges.defiWallets.map((wallet, index) => (
                    <li key={index} className="flex justify-between items-center bg-gray-50 p-2 rounded">
                      <span className="text-sm font-mono break-all">{wallet}</span>
                      <button
                        onClick={() => removeDefiWallet(wallet)}
                        className="text-red-600 hover:text-red-800 text-sm"
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;